import { render, staticRenderFns } from "./HTMLViewer.vue?vue&type=template&id=fc15492a&scoped=true&"
import script from "./HTMLViewer.vue?vue&type=script&lang=js&"
export * from "./HTMLViewer.vue?vue&type=script&lang=js&"
import style0 from "./HTMLViewer.vue?vue&type=style&index=0&id=fc15492a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc15492a",
  null
  
)

export default component.exports